import { motion } from 'framer-motion';

const LIGHTS_COUNT = 9;
const STEP = 0.07;

export default () => {
    return (
        <div className="semi-wheel-lights">
            {Array.from({ length: LIGHTS_COUNT }).map((_, index) => (
                <div className="light-sector" key={index}>
                    <motion.div
                        className="light"
                        animate={{
                            opacity: [
                                0.08,
                                0.35,
                                1,
                                0.55,
                                0.18,
                                0.08,
                            ],
                        }}
                        transition={{
                            duration: 0.32,
                            delay: index * STEP,
                            repeat: Infinity,
                            repeatDelay: (LIGHTS_COUNT - 1) * STEP,
                            ease: 'easeInOut',
                        }}
                    />
                </div>
            ))}
        </div>
    );
};